// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__JGyOa","choiceBoxes":"toolbarselects_choiceBoxes__1i9Qy","simpleField":"toolbarselects_simpleField__1zYRX"};